<script setup lang="ts">
  import { computed, type PropType } from 'vue'

  import { useI18n } from 'vue-i18n'

  import CPAvatar from '@ui/components/CPAvatar.vue'
  import CPText from '@ui/components/CPText.vue'

  import type { IConversationRecipient } from '../../types/conversation.types'

  const props = defineProps({
    recipient: {
      type: Object as PropType<IConversationRecipient | null>,
      default: null,
    },
  })

  defineOptions({
    name: 'ChatUserIntro',
  })

  const { t } = useI18n()

  const displayName = computed(() => props.recipient?.fullName || t('chats.user.unknownUser'))

  const username = computed(() => {
    if (props.recipient?.slug) {
      return `@${props.recipient.slug}`
    }
    return ''
  })

  const connectionText = computed(() => {
    return t('chats.userIntro.connection', { name: displayName.value })
  })
</script>

<template>
  <div class="flex flex-col items-center px-4 py-6 text-center">
    <!-- Large Avatar -->
    <div class="mb-3">
      <CPAvatar :src="recipient?.avatar" size="xl" :title="displayName" class="h-16 w-16 bg-border" />
    </div>

    <!-- User Name -->
    <CPText size="md" weight="semibold" class="mb-0.5 text-body">
      {{ displayName }}
    </CPText>

    <!-- Username/Slug -->
    <CPText v-if="username" size="sm" class="mb-2 text-secondary">
      {{ username }}
    </CPText>

    <!-- Connection Text -->
    <CPText size="sm" class="max-w-[220px] text-secondary">
      {{ connectionText }}
    </CPText>
  </div>
</template>
